import {Component, ComponentFactoryResolver, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {MatCheckboxChange, MatSelectChange, MatSnackBar, MatSnackBarConfig} from "@angular/material";
import {AbstractControl, FormBuilder, FormGroup, Validators} from "@angular/forms";
import {NgxLoopReportService} from "../ngx-loop-report/ngx-loop-report.service";
import {DayMonth, DayPipe, FullDatePipe, HourPipe, ShortDatePipe} from "../depends/pipe/date.pipe";
import {SecToDateTime} from "../sec-to-date-pipe";
import {TranslateService} from "../translate.service";
import {Location} from "@angular/common";
import moment, { Moment } from 'moment';
import {ReportParameter} from "../depends/report-parameter.model";
import {MultipleResourceSelectorComponent} from "../multiple-resource-selector/multiple-resource-selector.component";



@Component({
    selector: 'NgxLoopJsReport',
    templateUrl: './ngx-loop-jsreport.component.html',
    styleUrls: ['./ngx-loop-jsreport.component.css']
})
export class NgxLoopJsReportComponent implements OnInit {

    @Input() idReport: number;

    @ViewChild('multiSelector', {static: false}) multiSelector: MultipleResourceSelectorComponent<any>;

    @ViewChild("iframe", {static: true}) iframe: ElementRef<HTMLIFrameElement>;
    @ViewChild("stylePrint", {static: true}) stylePrint: ElementRef<HTMLStyleElement>;
    @ViewChild('pdfViewer', {static: true}) pdfViewer: ElementRef<HTMLIFrameElement>;

    loading: boolean = false;
    formGroup: FormGroup;

    parameters: ReportParameter[];


    constructor(
        private formBuilder: FormBuilder,
        private reportService: NgxLoopReportService,
        private fullDatePipe: FullDatePipe,
        private shortDatePipe: ShortDatePipe,
        private hourPipe: HourPipe,
        private dayMonth: DayMonth,
        private dayPipe: DayPipe,
        private secToDateTime: SecToDateTime,
        public translate: TranslateService,
        private _location: Location,
        private _snackBar: MatSnackBar,
    ) {
    }

    ngOnInit() {
        this.downloadParameters(this.idReport);
    }



    // ââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ
    // ââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ
    // ââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ
    // ââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ REPORT PARAMETERS âââââââââââââââââââââââ


    public downloadParameters(id) {
        this.loading = true;
        this.reportService.getReportParameters(id).then((parameters: ReportParameter[]) => {
            this.parameters = parameters;
            this.setFormGroup();
        }).finally(() => {
            this.loading = false;
        });
    }


    private setFormGroup() {
        let formModel = {};

        for (let param of this.parameters) {

            if (param.type == 'multiple_resource_selector') {
                formModel[param.name] = [param.data, (param.required ? Validators.required : null)];
            }else if (param.type == 'date_range') {
                let defaultValue = {begin: moment(), end: moment()};
                formModel[param.name] = [defaultValue, (param.required ? Validators.required : null)];
            }else if(param.type == "month"){
                formModel[param.name] = moment(formModel[param.name]).format("YYYY-MM").toString();
            }else if(param.type == "check"){
                formModel[param.name] = (formModel[param.name])?1:0;
            }else if(param.type == 'date'){
                console.log(param);
                if(param.default_value == "agora()")
                    param.default_value = moment().format("YYYY-MM-DD");
                formModel[param.name] = [param.default_value, (param.required ? Validators.required : null)];
            }else {
                console.log(param);
                formModel[param.name] = [param.default_value, (param.required ? Validators.required : null)];
            }
        }
        this.formGroup = this.formBuilder.group(formModel);
    }


    chosenMonthHandler(normalized: Moment, control:AbstractControl, datepicker) {
        control.setValue(normalized);
        datepicker.close();
      }
    // ââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ REPORT CONTENT âââââââââââââââââââââââââ


    public submit() {
        let body = {};

        for (let param of this.parameters) {
            let formValue = this.formGroup.value[param.name];

            if (param.type == "date_range") {
                body[param.name] = {};
                body[param.name]["begin"] = moment(formValue["begin"]).set({hours: 0, minutes: 0, seconds: 0}).format("YYYY-MM-DD HH:mm:ss");
                body[param.name]["end"] = moment(formValue["end"]).set({hours: 23, minutes: 59, seconds: 59}).format("YYYY-MM-DD HH:mm:ss");
            }else if (param.type == "multiple_resource_selector") {
                body[param.name] = formValue.map(d => d.id);
            }else if(param.type == "month"){
                body[param.name] = moment(body[param.name]).format("YYYY-MM").toString();
            }else if(param.type == "check"){
                body[param.name] = (body[param.name])?1:0;
            }else{
                body[param.name] = formValue;
            }

        }

        this.generateReport(body);
    }

    public onDateChange(controlName){
        this.formGroup.get(controlName).setValue(moment(this.formGroup.get(controlName).value).format("YYYY-MM-DD"));
    }

    private generateReport(body) {
        this.loading = true;
        this.reportService.getReportContent(this.idReport, body).then((response) => {
            let reader = new FileReader();
            reader.readAsDataURL(new Blob([response.body as Blob], {type: 'application/pdf'}));
            reader.onloadend = () => {
                let base64data = reader.result;
                this.pdfViewer.nativeElement.setAttribute('data', base64data.toString());
            }
        }).catch((error) => {
            console.log('Error', error)
        }).finally(() => {
            this.loading = false;
        });
    }


    // ââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ
    // ââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ UTILITIES âââââââââââââââââââââââââ


    public onDateRangeSelected(date: { begin: Moment, end: Moment }, param: ReportParameter) {
        this.formGroup.get(param.name).setValue({begin: date.begin, end: date.end});
    }

    public isAllMultipleChecked(param: ReportParameter) {
        let selectedValues = this.formGroup.get(param.name).value;
        return selectedValues.length >= param.data.length;
    }

    public toggleAllSelection(event: MatCheckboxChange, param: ReportParameter) {
        if (event.checked)
            this.formGroup.get(param.name).setValue(param.data);
        else
            this.formGroup.get(param.name).setValue([]);
    }


    public openSnackBar(message: string, type: string) {
        let config: MatSnackBarConfig = {
            panelClass: 'snack_' + type,
            duration: 6000,
            horizontalPosition: 'right',
            verticalPosition: 'bottom'
        };
        this._snackBar.open(message, "Ok", config);
    }

}
